import i18n from 'i18next';
export function i18nInit(locale) {
    var instance = i18n.createInstance();
    instance.use({
        type: 'backend',
        read: function (language, namespace, callback) {
            return import("./locales/messages_" + language + ".json")
                .then(function (translation) {
                return callback(null, translation);
            })
                .catch(function (error) { return callback(error); });
        },
    });
    instance
        .init({
        lng: locale,
        fallbackLng: 'en',
        keySeparator: false,
        react: {
            wait: true,
        },
    })
        .catch(console.error);
    return instance;
}
//# sourceMappingURL=i18n.js.map